import React from 'react';
import { PhoneIcon, PlayIcon } from 'lucide-react';
import { CONTACT } from '../../data/modalities';
export function WelcomeVideo() {
  return <section className="w-full bg-white py-20 sm:py-24" data-id="element-245" data-mp="3ldpkvyyt5ifi">
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-5 sm:px-8 lg:grid-cols-[1.05fr_0.95fr]" data-id="element-246" data-mp="38mapztzig88">
        <div data-id="element-247" data-mp="3vd6o89ql7k8b">
          <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-teal" data-id="element-248" data-mp="3vdgcnsvzhjbw">
            Welcome to JAG
          </p>
          <h2 className="mt-3 font-display text-3xl font-bold leading-tight tracking-tight text-navy sm:text-[2.4rem]" data-id="element-249" data-mp="37k6ngg9dkztx">
            A Welcome From Our Founder
          </h2>
          <p className="mt-5 max-w-xl text-[16px] leading-relaxed text-charcoal/75" data-id="element-250" data-mp="3ggflprlm9seh">
            A short welcome video will introduce JAG’s approach to simplifying
            modality decisions, implementation, training, and growth.
          </p>
          <a href={CONTACT.phoneHref} className="mt-8 inline-flex items-center gap-2 rounded-full bg-navy px-7 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-navy/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2" data-id="element-251" data-mp="2jx87rkt2xvx2">
            <PhoneIcon className="h-[18px] w-[18px]" data-id="element-252" data-mp="ak15r4m8ni1u" />
            Call Before You Buy
          </a>
        </div>
        <div className="relative overflow-hidden rounded-3xl border border-slate-200 bg-navy p-6 shadow-[0_24px_60px_-24px_rgba(26,27,75,0.32)] sm:p-8" data-id="element-253" data-mp="fgrm7t1ygfns">
          <div className="absolute inset-0 opacity-20" aria-hidden="true" data-id="element-254" data-mp="3iyjhbgbe1fq7">
            <div className="absolute left-1/2 top-1/2 h-[250px] w-[250px] -translate-x-1/2 -translate-y-1/2 rounded-full border border-teal" data-id="element-255" data-mp="3j0mhuua62r96" />
            <div className="absolute left-1/2 top-1/2 h-[150px] w-[150px] -translate-x-1/2 -translate-y-1/2 rounded-full border border-teal" data-id="element-256" data-mp="3sx8zzbb3z47i" />
          </div>
          <div className="relative flex aspect-video flex-col items-center justify-center rounded-2xl border border-white/15 bg-white/[0.05] text-center" data-id="element-257" data-mp="139zx56nwnr9o">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-teal text-white shadow-lg shadow-teal/20" data-id="element-258" data-mp="348ldz5iaqx8i">
              <PlayIcon className="ml-1 h-7 w-7 fill-current" data-id="element-259" data-mp="2zcwc2vit1491" />
            </span>
            <p className="mt-5 font-display text-xl font-bold text-white" data-id="element-260" data-mp="3da1fenr4vp0l">
              Welcome Video
            </p>
            <p className="mt-2 max-w-xs text-sm leading-relaxed text-white/65" data-id="element-261" data-mp="396v7lbodhps0">
              A short introduction to the JAG approach is coming soon.
            </p>
          </div>
        </div>
      </div>
    </section>;
}